import { createSelector, createSlice } from '@reduxjs/toolkit';
import { RootState } from '$store/rootReducer';
import {
  DeleteNoteAction,
  NotesState,
  SetNoteAction,
  UpdateNoteNoteAction,
  UpdateNoteNameAction,
} from '$store/notes/interface';

const initialState: NotesState = {
  isLoading: true,
  isLoadingMore: false,
  notes: [],
  note: {
    name: '',
    note: '',
  },
};

export const { reducer, actions } = createSlice({
  name: 'notes',
  initialState,
  reducers: {
    loadNote(state, _) {
      state.isLoading = true;
    },
    loadNotes(state) {
      state.isLoadingMore = true;
    },
    setNote(state, action: SetNoteAction) {
      for (let replacedNote of action.payload) {
        const index = state.notes.findIndex(
          (note) => note.userId === replacedNote.userId,
        );

        if (index !== -1) {
          state.notes[index] = replacedNote;
        } else {
          state.notes = [...state.notes, replacedNote];
        }
      }
    },
    updateNoteName(state, action: UpdateNoteNameAction) {
      state.note.name = action.payload.name;
    },
    updateNoteNote(state, action: UpdateNoteNoteAction) {
      state.note.note = action.payload.note;
    },
    deleteNote(state, _: DeleteNoteAction) {},
    setNoteName(state, action) {
      state.note.name = action.payload;
    },
    setNoteNote(state, action) {
      state.note.note = action.payload;
    },
    clearNote(state) {
      state.note.note = '';
      state.note.name = '';
    },
  },
});

export { reducer as notesReducer, actions as notesActions };
export const notesSelector = (state: RootState) => state.notes;

export const noteSelector = createSelector(
  notesSelector,
  (_, userId: number) => userId,
  (note, userId) => {
    return note.notes.find((item) => item.userId === userId);
  },
);
